<script setup>
import { useGlobalStore } from "@stores/global";
import IconPin from "@components/icons/Pin.vue";
import IconCheckmark from "@components/icons/Checkmark.vue";
import IconFlag from "@components/icons/Flag.vue";
import Button from "@components/Button.vue";

const globalStore = useGlobalStore();

const steps = [
    {
        icon: IconPin,
        title: "Click a country",
    },
    {
        icon: IconCheckmark,
        title: "Submit your vote",
    },
    {
        icon: IconFlag,
        title: "And see where Speed goes next",
    },
];
</script>

<template>
    <div
        class="flex w-full max-w-194 flex-col gap-3 lg:flex-row lg:items-center"
    >
        <div
            class="hidden h-full w-60 shrink-0 items-center justify-center md:flex"
        >
            <img
                src="https://speed-cdn.expedia.com/images/elements/vote-intro.jpg"
                class="rounded-2xl"
                alt=""
            />
        </div>

        <div
            class="flex flex-1 flex-col gap-8 overflow-y-auto p-6 lg:gap-10 lg:p-10"
        >
            <div class="flex flex-col gap-8 lg:pt-6">
                <p class="h5 leading-[0.9] font-bold tracking-tight uppercase">
                    Vote for IShowSpeed's next destination!
                </p>

                <div class="relative flex flex-col gap-4">
                    <div
                        class="border-marine-500 absolute top-[11.5px] bottom-[11.5px] left-6 w-0 border-l border-dashed"
                    />

                    <div
                        v-for="(step, i) in steps"
                        :key="i"
                        class="relative flex items-center gap-6"
                    >
                        <div
                            class="bg-marine-600 flex size-12 shrink-0 items-center justify-center"
                        >
                            <component
                                :is="step.icon"
                                class="size-6 text-yellow-400"
                            />
                        </div>
                        <div class="flex flex-col gap-2">
                            <p
                                class="body-md leading-[0.8] font-bold uppercase"
                            >
                                {{ step.title }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-auto flex lg:mt-0 lg:justify-end">
                <Button
                    className="w-full lg:w-auto"
                    @click="globalStore.closeModal()"
                    aria-label="Close"
                >
                    Let's do it!
                </Button>
            </div>
        </div>
    </div>
</template>
